module.exports = __webpack_public_path__ + "img/price_cash.628a2a8f.svg";